import BasicCard from "@components/cards/BasicCard";
import { useHistory, useLocation } from "react-router-dom";
import { FunctionComponent } from "react";
import { useTranslation } from "react-i18next";
import BasicButton from "@components/buttons/BasicButton";
import { useViewport } from "@utils/breakpoints-helper";
import { RightOutlined } from "@ant-design/icons";
import { setOrigin } from "@state/session/SessionEvents";

interface DashboardCardProps {
  link: string;
  icon: JSX.Element;
  iconMobile: JSX.Element;
  title: string;
  subtitle: string;
  actionLabel: string;
}
const HomeCard: FunctionComponent<DashboardCardProps> = ({
  link,
  icon,
  iconMobile,
  title,
  subtitle,
  actionLabel,
}) => {
  const location = useLocation();
  const history = useHistory();
  const { t } = useTranslation();
  const { width } = useViewport();

  return (
    <div className="card-home m-md-4">
      {width >= 768 && (
        <BasicCard className="home-card-image">{icon}</BasicCard>
      )}
      <div className="d-flex flex-column align-items-md-center justify-content-center">
        {width < 768 && <div>{iconMobile}</div>}
        <h4 className="mt-2 mt-md-4 mb-2">{t(title)}</h4>
        <div className="text-sm mb-4">{t(subtitle)}</div>
        {width >= 768 && (
          <BasicButton
            text={t(actionLabel)}
            size="lg"
            onClick={() => {
              history.push(link);
              const origin =
                new URLSearchParams(location.search).get("origin") ?? undefined;
              setOrigin(origin);
            }}
          />
        )}
      </div>
      {width < 768 && (
        <BasicButton
          icon={<RightOutlined aria-hidden="true" />}
          className="btn-icon ms-4"
          onClick={() => {
            history.push(link);
            const origin =
              new URLSearchParams(location.search).get("origin") ?? undefined;
            setOrigin(origin);
          }}
        />
      )}
    </div>
  );
};

export default HomeCard;
